/**
 * Admin Layout Component
 * Provides consistent layout and styling for all admin pages
 */

import React from 'react';

interface AdminLayoutProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: '7xl' | 'screen-2xl' | 'none';
}

export function AdminLayout({
  children,
  className = '',
  maxWidth = 'none'
}: AdminLayoutProps) {
  const maxWidthClass = {
    '7xl': 'max-w-7xl',
    'screen-2xl': 'max-w-[1800px]',
    'none': ''
  }[maxWidth];

  return (
    <div
      className={`@container/admin-layout ${maxWidthClass} mx-auto w-full space-y-4 @[760px]/admin-layout:space-y-5 @[1120px]/admin-layout:space-y-6 ${className}`}
    >
      {children}
    </div>
  );
}
